import ContinueButton from 'components/ContinueButton';
import { Checkbox, DriftSnackbar } from 'drift-ui';
import styles from './Authority.scss';
import baseStyles from './BaseFormStyles.scss';
import React, { useState } from 'react';
import cx from 'classnames';
import { DO_APPLICATION_TYPE } from 'client-experience-toolbox';
import { useTranslation } from 'react-i18next';
import { useFormNetworkCalls } from 'utils/useFormNetworkCalls';

export const Authority = () => {
  const [usCitizenChecked, setUsCitizenChecked] = useState(false);
  const [authorizedChecked, setAuthorizedChecked] = useState(false);
  const [error, setError] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { setSectionComplete } = useFormNetworkCalls(DO_APPLICATION_TYPE.BANKING);
  const { t } = useTranslation();
  const onContinue = async () => {
    if (!usCitizenChecked || !authorizedChecked) {
      setError(true);
      return;
    }
    try {
      setIsLoading(true);
      const sectionsCompletion = {
        authority: { completedAt: Date.now().valueOf() },
      };
      await setSectionComplete(sectionsCompletion);
    } catch {
      setSnackbar(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={cx(baseStyles.formContainer, styles.authorityFormContainer)}>
      <div className={styles.container}>
        <div className={cx(styles.checkboxContainer, error && styles.errorCheckboxContainer)}>
          <p className={styles.checkboxTitle}>{t('digital_onboarding.banking.authority.by_checking_the_box')}</p>
          {error && <p className={styles.errorText}>{t('digital_onboarding.banking.authority.error_text')}</p>}
          <div>
            <label className={styles.checkbox}>
              <Checkbox
                checked={usCitizenChecked}
                slotProps={{
                  input: {
                    'data-nid-target': 'authority-us-citizen-checkbox',
                  } as React.InputHTMLAttributes<HTMLInputElement>,
                }}
                onChange={() => {
                  setError(false);
                  setUsCitizenChecked((prevCitizenCheck) => !prevCitizenCheck);
                }}
              />
              <p className={styles.checkboxText}>{t('digital_onboarding.banking.authority.us_citizen')}</p>
            </label>
            <label className={styles.checkbox}>
              <Checkbox
                checked={authorizedChecked}
                slotProps={{
                  input: {
                    'data-nid-target': 'authority-authorized-checkbox',
                  } as React.InputHTMLAttributes<HTMLInputElement>,
                }}
                onChange={() => {
                  setError(false);
                  setAuthorizedChecked((prevAuthorizedCheck) => !prevAuthorizedCheck);
                }}
              />
              <p className={styles.checkboxText}>
                {t('digital_onboarding.banking.authority.authorized_to_open_account')}
              </p>
            </label>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <ContinueButton
            title={t('digital_onboarding.banking.authority.agree_and_continue')}
            buttonStyles={styles.buttonStyles}
            handleContinueClick={onContinue}
            isPatching={isLoading}
          />
        </div>
      </div>
      <DriftSnackbar
        open={snackbar}
        variant="error"
        message={t('digital_onboarding.banking.authority.please_try_again')}
        autoHideDuration={3000}
        onClose={(prev) => setSnackbar(prev)}
      />
    </div>
  );
};
